import { Label, Switch } from "@sportscanner/ui";

// Shared presentational controls for the club settings forms (Access & contact,
// Limits). Kept here so both pages render identical section/row chrome.

export function Section({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <section className="bg-white rounded-xl border border-neutral-200 p-5 space-y-4">
      <h2 className="text-sm font-semibold text-neutral-800">{title}</h2>
      <div className="space-y-4">{children}</div>
    </section>
  );
}

export function Subsection({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <section className="space-y-2">
      <h3 className="text-xs font-semibold tracking-wider uppercase text-neutral-500">
        {title}
      </h3>
      <div className="space-y-4">{children}</div>
    </section>
  );
}

export function Row({
  id,
  label,
  hint,
  checked,
  onCheckedChange,
  disabled,
}: {
  id: string;
  label: string;
  hint: string;
  checked: boolean;
  onCheckedChange: (v: boolean) => void;
  disabled?: boolean;
}) {
  return (
    <div className="flex items-start justify-between gap-3">
      <div className="flex-1 min-w-0">
        <Label htmlFor={id} className="text-sm font-medium text-neutral-800">
          {label}
        </Label>
        <p className="text-xs text-neutral-500 mt-0.5">{hint}</p>
      </div>
      <Switch
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
      />
    </div>
  );
}
